import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalSearchViewGroup, GlobalSearchViewResult } from '../global-search.utils';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-global-search',
    standalone: true,
    imports: [CommonModule, TranslocoPipe],
    templateUrl: './global-search.component.html',
    styleUrls: ['./global-search.component.css']
})
export class GlobalSearchComponent {
    @Input() term = '';
    @Input() open = false;
    @Input() loading = false;
    @Input() groups: GlobalSearchViewGroup[] = [];
    @Input() highlightedIndex = 0;

    @Output() termChange = new EventEmitter<string>();
    @Output() opened = new EventEmitter<void>();
    @Output() blurred = new EventEmitter<void>();
    @Output() keydownSearch = new EventEmitter<KeyboardEvent>();
    @Output() cleared = new EventEmitter<void>();
    @Output() resultSelected = new EventEmitter<GlobalSearchViewResult>();

    get results(): GlobalSearchViewResult[] {
        return this.groups.flatMap(group => group.results);
    }

    trackGroup(index: number, group: GlobalSearchViewGroup): string {
        return `${group.key}-${index}`;
    }

    isResultActive(result: GlobalSearchViewResult): boolean {
        return this.results[this.highlightedIndex]?.id === result.id
            && this.results[this.highlightedIndex]?.route === result.route;
    }
}
